exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-form-field {\r\n    padding: 5px;\r\n}\r\n\r\n.mat-form-field {\r\n    width: 260px !important;\r\n}\r\n\r\n.long-form-field {\r\n    width: 96% !important;\r\n}\r\n\r\n.mat-dialog-content{\r\n    padding:0px;\r\n}\r\n\r\n.mat-dialog-actions:last-child {\r\n    margin-bottom: -24px;\r\n    margin-left: -19px;\r\n}\r\n\r\nbutton.reverse-button, button.mat-button.reverse-button {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.ptag {\r\n    color: red;\r\n    font-size: small;\r\n    margin-left: 5px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/program-add/program-add.component.css
// module id = ../../../../../src/app/loanprograms/program-add/program-add.component.css
// module chunks = main